export default "__VITE_ASSET__BbnP4fip__"